import { render, staticRenderFns } from "./FrameworkAccessReportList.vue?vue&type=template&id=32d2d41d"
import script from "./FrameworkAccessReportList.vue?vue&type=script&lang=js"
export * from "./FrameworkAccessReportList.vue?vue&type=script&lang=js"
import style0 from "./FrameworkAccessReportList.vue?vue&type=style&index=0&id=32d2d41d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
